import React from 'react';
import { checkPermission } from '../utils/permission';
import HandlePhoneNumber from './HandlePhoneNumber';
import { repeatPhoneNumber } from '../utils/helpers';

const PhoneNumberList = ({ phones, relatedPhones }) => {

    try {
        const permission = checkPermission('customer', 'phonenumber');
        const inputPinCode = checkPermission('customer', 'input_pin_code');

        // Kiểm tra phones và relatedPhones hợp lệ
        const isValidArray = (arr) => Array.isArray(arr) && arr.length > 0;

        const AllRelatedPhones = isValidArray(relatedPhones) ? relatedPhones?.flatMap((rel) =>
            rel.phones?.map((phone) => ({
                phone: phone.phone,
                customer_id: phone.customer_id,
                is_primary: phone.is_primary
            })) || []
        ) || []
            : [];
        const allPhones = [
            ...(isValidArray(phones) ? phones.map((phone) => ({
                phone: phone?.phone,
                customer_id: phone?.customer_id,
                is_primary: phone?.is_primary
            })) : []),
            ...AllRelatedPhones,
        ];

        return (
            <>
                {allPhones.length > 0 && allPhones.map((item, idx) => (
                    <div key={`${item.customer_id}-${idx}`}>
                        <HandlePhoneNumber
                            isPrimary={item.is_primary}
                            showIsPrimary={allPhones.length > 1}
                            permission={permission}
                            inputPinCode={inputPinCode}
                            customer_id={item.customer_id}
                            hiddenPhoneNumber={repeatPhoneNumber(item.phone)}
                            fullPhoneNumber={item.phone}
                        />
                    </div>
                ))}
            </>
        );
    } catch (error) {
        console.error('Lỗi khi xử lý danh sách số điện thoại:', error);
    }
};

export default PhoneNumberList;
